import { cn } from "@izicvs/utils";
import { forwardRef } from "react";

export type InputProps = {
  hasError?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, hasError = false, ...props }, ref) => {
    // Base styles
    const baseStyles = "flex h-9 w-full rounded-full border bg-transparent px-3 py-0.5";

    // Text styles with responsive sizes
    const textStyles = "!text-md lg:text-sm placeholder:opacity-80";

    // Interaction states
    const interactionStyles =
      "hover:bg-secondary/20 focus:border-primary focus:bg-secondary/20 focus-visible:outline-none";

    // Special elements and states
    const specialStyles =
      "ring-0 ring-offset-transparent focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50";

    // Number input specific styles
    const numberStyles =
      "[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none";

    // File input specific styles
    const fileStyles =
      "file:border-0 file:bg-transparent file:pt-1 file:text-sm file:font-medium file:text-primary";

    // Conditional border color (only apply border-color, not the border itself)
    const borderColor = hasError ? "border-error" : "border-border";

    return (
      <input
        ref={ref}
        type={type}
        autoComplete="off"
        className={cn(
          baseStyles,
          textStyles,
          interactionStyles,
          specialStyles,
          numberStyles,
          fileStyles,
          borderColor,
          "transition-colors",
          className,
        )}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";
